exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".battery-graph{background-color:white !important;border-radius:5px;padding:5px;margin-top:10px}.no-measurements{margin-top:10px}.current-voltage{background-color:white;padding-top:3px !important;padding-bottom:3px !important}.voltage-good{background-color:green}.voltage-bad{background-color:red}.no-current-value{background-color:gray}.current-voltage-span{color:white;padding:5px;border-radius:4px}.current-voltage-span>i{margin-left:.1rem}.voltage-suffix{position:absolute;top:7px;right:30px;z-index:10}\n", ""]);

// exports
